import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import useTranslator from "../../hooks/useTranslator";
import {
  calculateEffortRate,
  getCustomIncomeDetails,
  haveValue,
  shouldDeductNextView,
  isDefaulter,
  toast,
  amlKycChecks,
  getFieldForPolicies,
  calculateFinalScore,
  getRentPercentage,
  calculateOverlayScore,
  getCustomIncome,
  getUserDisplayName,
  haveMissingDniOrNieFromVerifiedSource,
  formatPropertyAddress,
  toTitleCase,
} from "../../helper/common";
import AuthContext from "../../context/auth/AuthContext";
import AwardPropertyPopup from "./AwardPropertyPopup";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import LandLordContext from "../../context/landlord/LandLordContext";
import Cancelimg from "../../assets/img/cancel-01.svg";
import CloseIcon from "../../assets/img/closeIcon.svg";
import SkorDefaultLoader from "../../assets/img/skorDefaultLoader.gif";
import UserIcon from "../../assets/img/user-icon.svg";
import DownloadIcon from "../../assets/img/downloadIcon.svg";
import Loader from "../Loader";
import SuccessAwardedPropModal from "./SuccessAwardedPropModal";
import ServingPromptModal from "../../pages/landlord/profile-request/ServingPromptModal";
import PurchaseInsurancePopup from "./PurchaseInsurance";
import moment from "moment";
import { IoStopwatchOutline } from "react-icons/io5";
import { WORKSPACE_ROLES_CAPABILITIES } from "../../Utils/workspaceRoleCapabilities";
import ButtonActionTooltip from "../ErrorModal/ButtonActionTooltip";
import InsuranceReviewModal from "./InsuranceReviewModal";
import InsuranceSimulationErrorsModal from "./InsuranceSimulationErrorsModal";

const LinkedPropertiesPopup = ({
  detailsShow,
  setDetailsShow,
  setPropData,
  property,
  tanentData,
  handleSaveChanges,
  saveTanentLoading,
  setSelectedTanents,
  selectedTanents,
  searchText,
  setSearchText,
  onPropertyAward,
  setPreselectedTanents,
  setsaveTanentLoading,
  loadData,
  currentLang,
}) => {
  const { _t } = useTranslator();
  const location = useLocation();
  const STATUS_STYLES = {
    yellow: {
      backgroundColor: "#FFFBEC",
      color: "#E1BB20",
      border: ".1389vw solid #F2E09B",
      text: _t("manualReview"),
      img: "/images/warning.svg",
      fw: "600",
      deaIndividualText: _t("reviewDea"),
    },
    grey: {
      backgroundColor: "#F7F7F7",
      color: "#253837",
      border: ".1389vw solid #E6E6E6",
      text: _t("selectTenantsToCheckApproval"),
      fw: "500",
      deaIndividualText: _t("notFoundDea"),
    },
    green: {
      backgroundColor: "#F2FBE9",
      color: "#82CF3F",
      border: ".1389vw solid #DAECC8",
      text: _t("approved"),
      img: "/images/tick-new.svg",
      fw: "600",
      deaIndividualText: _t("eligibleDea"),
    },
    red: {
      backgroundColor: "#FFE2E2",
      color: "#FF3C3C",
      border: ".1389vw solid #EB9B9C",
      text: _t("notApproved"),
      img: "/images/notApproved.svg",
      fw: "600",
      deaIndividualText: _t("hardFailDea"),
    },
  };
  const isPropertyAwarded = property?.is_awarded;
  const navigate = useNavigate();
  const { workspaceId } = useParams();
  const authContext = useContext(AuthContext);
  const landLordContext = useContext(LandLordContext);
  const queryParameters = new URLSearchParams(window.location.search);
  const initialSharedProfileIdsRef = useRef(
    new URLSearchParams(window.location.search).getAll("sharedprofileid")
  );
  const { user, setLoading } = authContext;
  const {
    multiPropAward,
    sendInvitationToTenant,
    multiPropUnAward,
    getShareProfilesForProperty,
    updatePropertyDetails,
    customPolicyDetails,
    deaWorkspace,
    checkInsuranceDocumentStatus,
    runInsuranceSimulation,
    checkMutuaConsents,
  } = landLordContext;
  const runIdRef = useRef(0);

  const [awardPopupModal, setAwardPopupModal] = useState(false);
  const [insuracePopupModal, setInsuracePopupModal] = useState(false);
  const [selectedTenant, setSelectedTenant] = useState([]);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [sharerEmail, setSharerEmail] = useState(null);
  const [sharerName, setSharerName] = useState(null);
  const [sendInvitationLoading, setSendInvitationLoading] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showUnAwardSuccessPopup, setShowUnAwardSuccessPopup] = useState(false);
  const [successTenant, setSuccessTenant] = useState([]);
  const [propertyAwardedSelectedTenant, setPropertyAwardedSelectedTenant] =
    useState([]);
  const [propertyShareProfiles, setPropertyShareProfiles] = useState([]);
  const [linkingTenantIds, setLinkingTenantIds] = useState([]);
  const [unlinkingTenantIds, setUnlinkingTenantIds] = useState([]);
  const [servingPromptModal, setServingPromptModal] = useState(false);
  const [currentProfile, setCurrentProfile] = useState(null);
  const [rent, setRent] = useState(property?.report_rent ?? 0);
  const [propertyRentError, setPropertyRentError] = useState(false);
  const [tenantResults, setTenantResults] = useState({});
  const [deaResult, setDeaResult] = useState([]);
  const [allDeaResult, setAllDeaResult] = useState({});
  const [statusStyle, setStatusStyle] = useState(STATUS_STYLES.grey);
  const [giveInsurance, setGiveInsurance] = useState(false);
  const [resultLoader, setResultLoader] = useState(false);
  const [checkStatusLoading, setCheckStatusLoading] = useState(false);
  const [simulationLoading, setSimulationLoading] = useState(false);
  const [insuranceSimulationErrorModal, setInsuranceSimulationErrorModal] =
    useState(false);
  const [insuranceSimulationErrors, setInsuranceSimulationErrors] = useState(
    []
  );
  const [showInsuranceReviewModal, setShowInsuranceReviewModal] =
    useState(false);

  const isInsuranceEnabledWorkspace = ["UY5I2V"].includes(
    user?.current_workspace?.uuid
  );

  useEffect(() => {
    const initialIds = initialSharedProfileIdsRef.current;

    if (haveValue(initialIds) && haveValue(propertyShareProfiles)) {
      const idSet = new Set(initialIds);
      const filteredEntries = propertyShareProfiles.filter((item) =>
        idSet.has(item._id)
      );

      // Clear URL params
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.delete("sharedprofileid");
      const newQuery = currentParams.toString();
      const baseUrl = workspaceId ? `/${workspaceId}/home` : `/home`;
      const newUrl = newQuery ? `${baseUrl}?${newQuery}` : baseUrl;
      window.history.replaceState(null, "", newUrl);

      // Clear the ref so this never runs again
      // initialSharedProfileIdsRef.current = [];

      setSelectedTenant(filteredEntries);
    }
  }, [propertyShareProfiles]); // Only depends on propertyShareProfiles

  const fetchShareProfileData = async (showLoading = false, setList = true) => {
    try {
      if (showLoading) {
        setsaveTanentLoading(true);
      }

      const data = await getShareProfilesForProperty(property?._id);

      setPropertyShareProfiles(data?.sharedProfiles ?? []);
      if (data?.sharedProfiles) {
        const dataArray = Array.isArray(data.sharedProfiles)
          ? data.sharedProfiles
          : [];

        const updatedData = dataArray.map((item) => {
          const tenant = item?.tenant_id || item?.tenantid;
          return {
            label: tenant?.fname + " " + (tenant?.lname ?? ""),
            value: tenant?._id,
          };
        });

        setPreselectedTanents(updatedData);

        if (setList) {
          setSelectedTanents(updatedData.map((item) => item.value));
        }
      }
    } catch (error) {
      console.log("Failed to fetch data", error);
    } finally {
      if (showLoading) {
        setsaveTanentLoading(false);
      }
    }
  };

  useEffect(() => {
    setStatusStyle(STATUS_STYLES.grey);
    if (
      selectedTenant?.length > 0 &&
      haveValue(customPolicyDetails?.scoringConfig) &&
      haveValue(customPolicyDetails?.overlayConfig) &&
      haveValue(customPolicyDetails?.policyConfig)
    ) {
      console.log("GOING IN IF");
      runIdRef.current += 1;
      const currentRunId = runIdRef.current;

      // Optional: Clear previous results

      if (user?.current_workspace?.dea_rules_activated && deaWorkspace) {
        setTenantResults({});

        setDeaResult([]);

        policyCalculate(currentRunId);
      } else {
        getStatusStyle();
      }
    }
  }, [selectedTenant, customPolicyDetails, rent, giveInsurance, user]);

  useEffect(() => {
    if (!haveValue(searchText)) {
      fetchShareProfileData(true, true);
    }
  }, []);

  useEffect(() => {
    setRent(property?.report_rent);
  }, [property]);

  useEffect(() => {
    if (deaResult?.length > 0) {
      setResultLoader(true);

      // ✅ Flatten dataset
      const allProfiles = deaResult.flatMap((tenant) => [
        tenant,
        ...(tenant?.guarantors || []),
      ]);

      const highPointProfile = allProfiles.reduce((max, current) => {
        if (!max) return current;

        return current?.DEA_SCORE?.finalScore > max?.DEA_SCORE?.finalScore
          ? current
          : max;
      }, null);

      const profilesHaveMissingDocs = allProfiles.some(
        (item) => item?.vals?.DOCUMENTATION > 0
      );

      const hasHardFailEntries = allProfiles.some(
        (item) => item?.errorEntries?.length > 0
      );

      const haveMissingDniOrNie =
        haveMissingDniOrNieFromVerifiedSource(allProfiles);

      // 🎯 SAME DECISION LOGIC
      if (hasHardFailEntries) {
        setStatusStyle(STATUS_STYLES.red);
      } else if (
        highPointProfile?.DEA_SCORE?.finalScore > 4 &&
        !profilesHaveMissingDocs &&
        !haveMissingDniOrNie
      ) {
        setStatusStyle(STATUS_STYLES.green);
      } else {
        setStatusStyle(STATUS_STYLES.yellow);
      }

      setResultLoader(false);
    }
  }, [deaResult]);

  async function policyCalculate(currentRunId) {
    setResultLoader(true);
    try {
      let tenantIncomeSum = 0;
      let guarantorIncomeSum = 0;

      // ---- SAME INCOME LOGIC ----
      for (let entry of selectedTenant) {
        const incomeSelection = entry?.income_selection;
        const tenantInfo = entry?.tenantid;

        const tenantIncome = getCustomIncomeDetails(
          tenantInfo,
          user,
          _t,
          incomeSelection?.tenant_source,
          undefined,
          undefined,
          deaWorkspace
        );

        tenantIncomeSum += tenantIncome?.amount ?? 0;

        const guarantors = tenantInfo?.gurantor_id || [];

        for (let g of guarantors) {
          const guarantorIncome = getCustomIncomeDetails(
            g,
            user,
            _t,
            incomeSelection?.guarantor_sources?.[g?._id],
            undefined,
            undefined,
            deaWorkspace
          );

          guarantorIncomeSum += guarantorIncome?.amount ?? 0;
        }
      }

      const totalIncome = tenantIncomeSum + guarantorIncomeSum;

      const finalEffortRate =
        getRentPercentage(totalIncome, rent)?.roundValue ?? "0";

      const resultDea = [];

      for (let entry of selectedTenant) {
        if (runIdRef.current !== currentRunId) return;

        try {
          // ===== TENANT =====
          const temp = await getFieldForPolicies(
            entry?.tenantid,
            user,
            finalEffortRate,
            giveInsurance,
            deaWorkspace
          );

          if (runIdRef.current !== currentRunId) return;

          const DEA_SCORE = calculateOverlayScore(
            temp.EFFORT_RATE_SCORE,
            temp.TENURE,
            temp.EMPLOYMENT_PREDICTABILITY,
            temp.SECTOR_CYCLICALITY,
            temp.EMPLOYER_STABILITY
          );

          const errorEntries = Object.entries(temp).filter(
            ([_, value]) => value?.isHardFail === true
          );

          let guarantorOutsideSpain = false;
          const checkGuarantors = entry?.tenantid?.gurantor_id || [];
          for (let g of checkGuarantors) {
            const forensicData =
              g?.tenant_extra_field_id?.forensic_financial_data;
            if (forensicData) {
              for (let key in forensicData) {
                if (
                  forensicData[key]?.origin &&
                  forensicData[key]?.origin !== "Local"
                ) {
                  guarantorOutsideSpain = true;
                  break;
                }
              }
            }
            if (guarantorOutsideSpain) break;
          }
          if (guarantorOutsideSpain) {
            errorEntries.push([
              "GUARANTOR_OUTSIDE_SPAIN",
              { isHardFail: true, label: "guarantorLivingOutsideSpain" },
            ]);
          }

          // ===== GUARANTORS (NEW) =====
          const guarantors = entry?.tenantid?.gurantor_id || [];

          const guarantorResults = [];

          for (let g of guarantors) {
            const gTemp = await getFieldForPolicies(
              g,
              user,
              finalEffortRate,
              giveInsurance,
              deaWorkspace
            );

            const gScore = calculateOverlayScore(
              gTemp.EFFORT_RATE_SCORE,
              gTemp.TENURE,
              gTemp.EMPLOYMENT_PREDICTABILITY,
              gTemp.SECTOR_CYCLICALITY,
              gTemp.EMPLOYER_STABILITY
            );

            const gErrors = Object.entries(gTemp).filter(
              ([_, value]) => value?.isHardFail === true
            );

            guarantorResults.push({
              ...g,
              DEA_SCORE: gScore,
              errorEntries: gErrors,
              vals: gTemp,
            });
          }

          // ===== LABEL (UNCHANGED) =====
          const label = getUserDisplayName(entry?.tenantid);

          entry.tenantid.label = label;

          temp.EFFORT_RATE_SCORE = temp?.EFFORT_RATE_SCORE?.EFFORT_RATE_SCORE;

          // ===== PUSH (ONLY ADDITION = guarantors) =====
          resultDea.push({
            ...entry?.tenantid,
            DEA_SCORE,
            errorEntries,
            vals: temp,
            guarantors: guarantorResults, // ✅ NEW FIELD
          });

          // ===== EXISTING SCORING (UNCHANGED) =====
          const result = await calculateFinalScore(
            customPolicyDetails.scoringConfig,
            customPolicyDetails.overlayConfig,
            customPolicyDetails.policyConfig,
            temp
          );

          if (runIdRef.current !== currentRunId) return;

          result.errorEntries = errorEntries;
          result.isHardFail = errorEntries?.length > 0;

          setTenantResults((prev) => ({
            ...prev,
            [entry?._id]: result,
          }));
        } catch (err) {
          if (runIdRef.current !== currentRunId) return;
          console.error("Unexpected error:", err);
        }
      }

      setDeaResult(resultDea);
    } catch (err) {
      console.log(err);
    } finally {
      setResultLoader(false);
    }
  }

  const processAssignPropData = async () => {
    let tenantIncomeSum = 0;
    let guarantorIncomeSum = 0;

    const allEntires = getName();

    // ---- SAME INCOME LOGIC (UNCHANGED) ----
    for (let entry of allEntires) {
      const incomeSelection = entry?.income_selection;
      const tenantInfo = entry?.tenantid;

      const tenantIncome = getCustomIncomeDetails(
        tenantInfo,
        user,
        _t,
        incomeSelection?.tenant_source,
        undefined,
        undefined,
        deaWorkspace
      );

      tenantIncomeSum += tenantIncome?.amount ?? 0;

      const guarantors = tenantInfo?.gurantor_id || [];

      for (let g of guarantors) {
        const guarantorIncome = getCustomIncomeDetails(
          g,
          user,
          _t,
          incomeSelection?.guarantor_sources?.[g?._id],
          undefined,
          undefined,
          deaWorkspace
        );

        guarantorIncomeSum += guarantorIncome?.amount ?? 0;
      }
    }

    const totalIncome = tenantIncomeSum + guarantorIncomeSum;

    const finalEffortRate =
      getRentPercentage(totalIncome, rent)?.roundValue ?? "0";

    const resultDeaObject = {};

    // ---- PARALLEL PROCESSING (SAFE OPTIMIZATION) ----
    await Promise.all(
      allEntires.map(async (entry) => {
        try {
          // ===== TENANT (UNCHANGED LOGIC) =====
          const temp = await getFieldForPolicies(
            entry?.tenantid,
            user,
            finalEffortRate,
            giveInsurance,
            deaWorkspace
          );

          const DEA_SCORE = calculateOverlayScore(
            temp.EFFORT_RATE_SCORE,
            temp.TENURE,
            temp.EMPLOYMENT_PREDICTABILITY,
            temp.SECTOR_CYCLICALITY,
            temp.EMPLOYER_STABILITY
          );

          const errorEntries = Object.entries(temp).filter(
            ([key, value]) => value?.isHardFail === true
          );

          let guarantorOutsideSpain = false;
          const checkGuarantors = entry?.tenantid?.gurantor_id || [];
          for (let g of checkGuarantors) {
            const forensicData =
              g?.tenant_extra_field_id?.forensic_financial_data;
            if (forensicData) {
              for (let key in forensicData) {
                if (
                  forensicData[key]?.origin &&
                  forensicData[key]?.origin !== "Local"
                ) {
                  guarantorOutsideSpain = true;
                  break;
                }
              }
            }
            if (guarantorOutsideSpain) break;
          }
          if (guarantorOutsideSpain) {
            errorEntries.push([
              "GUARANTOR_OUTSIDE_SPAIN",
              { isHardFail: true, label: "guarantorLivingOutsideSpain" },
            ]);
          }

          // ===== GUARANTORS (NEW - NON BREAKING) =====
          const guarantors = entry?.tenantid?.gurantor_id || [];

          const guarantorResults = await Promise.all(
            guarantors.map(async (g) => {
              try {
                const gTemp = await getFieldForPolicies(
                  g,
                  user,
                  finalEffortRate,
                  giveInsurance,
                  deaWorkspace
                );

                const gScore = calculateOverlayScore(
                  gTemp.EFFORT_RATE_SCORE,
                  gTemp.TENURE,
                  gTemp.EMPLOYMENT_PREDICTABILITY,
                  gTemp.SECTOR_CYCLICALITY,
                  gTemp.EMPLOYER_STABILITY
                );

                const gErrors = Object.entries(gTemp).filter(
                  ([_, value]) => value?.isHardFail === true
                );

                return {
                  ...g,
                  DEA_SCORE: gScore,
                  errorEntries: gErrors,
                  vals: gTemp,
                };
              } catch (err) {
                console.error("Guarantor error:", err);
                return null;
              }
            })
          );

          // ===== LABEL (UNCHANGED) =====
          const label = getUserDisplayName(entry?.tenantid);

          entry.tenantid.label = label;

          temp.EFFORT_RATE_SCORE = temp?.EFFORT_RATE_SCORE?.EFFORT_RATE_SCORE;

          // ===== FINAL OBJECT (ONLY ADDITION) =====
          resultDeaObject[entry?._id] = {
            ...entry?.tenantid,
            DEA_SCORE,
            errorEntries,
            vals: temp,

            // ✅ ONLY NEW FIELD (safe)
            guarantors: guarantorResults?.filter(Boolean),
          };
        } catch (err) {
          console.error("Unexpected error:", err);
        }
      })
    );

    setAllDeaResult(resultDeaObject);
  };

  const handleChangeRent = (e) => {
    const value = e.target.value;

    if (/^\d*\.?\d{0,2}$/.test(value)) {
      setRent(value);
      setPropertyRentError(false);
    }
  };

  const handleBlurRent = async () => {
    if (!rent) {
      setPropertyRentError(true);
      return;
    }
    await updatePropertyDetails(property?._id, {
      report_rent: rent ?? "",
    });
    loadData();
  };

  useEffect(() => {
    if (propertyShareProfiles?.length > 0) {
      setAllDeaResult({});
      processAssignPropData();
    }
  }, [propertyShareProfiles, rent]);

  useEffect(() => {
    if (isPropertyAwarded) {
      const tempArr = propertyShareProfiles?.filter((val) =>
        property?.current_tenant?.includes(val?.tenantid?._id)
      );
      setPropertyAwardedSelectedTenant(tempArr);
    }
  }, [isPropertyAwarded, propertyShareProfiles, property]);

  const calculateRentAmount = (fullinfo) => {
    const user_income_sources = fullinfo?.income_selection;
    const gurantor_income_sources = user_income_sources?.guarantor_sources;
    const disabledIncomeSourcesIds = fullinfo?.excluded_income_source_ids ?? [];

    const tInfo = fullinfo?.tenantid;

    const user_income = getCustomIncomeDetails(
      tInfo,
      user,
      _t,
      user_income_sources?.tenant_source,
      undefined,
      undefined,
      deaWorkspace
    );

    // gurantor's income
    let totalGurantorIncome = 0;
    let allGurantorIncomes = [];
    let allGurantors = tInfo?.gurantor_id;

    if (Array.isArray(allGurantors)) {
      allGurantors.forEach((gurantor) => {
        if (haveValue(gurantor)) {
          const income = getCustomIncomeDetails(
            gurantor,
            user,
            _t,
            gurantor_income_sources?.[gurantor?._id],
            undefined,
            undefined,
            deaWorkspace
          );

          // if (!disabledIncomeSourcesIds?.includes(income?.all_sources?._id)) {
          totalGurantorIncome += income?.amount || 0;
          // }
          allGurantorIncomes.push(income);
        }
      });
    }

    // const userAmount = !disabledIncomeSourcesIds?.includes(
    //   user_income?.all_sources?._id
    // )
    //   ? +user_income?.amount
    //   : 0;
    const userAmount = +user_income?.amount;

    // const combinedIncome = userAmount + +totalGurantorIncome;

    // const data = {
    //   ...fullinfo,
    //   rent_percentage: 35,
    // };
    // let temp_obj = calculateEffortRate(combinedIncome, user, data);

    // return !Number.isNaN(temp_obj?.effort_amount)
    //   ? Math.round(Number(temp_obj.effort_amount))
    //   : 0;

    return getRentPercentage(userAmount, rent)?.roundValue;
  };

  const handleAwardPropFlow = () => {
    setLoading(true);
    sendAwardPropEmail()
      .then((res) => {
        setShowSuccessPopup(true);
        if (setPropData) setPropData({});
        setSelectedTenant([]);
        setSuccessTenant(res);
        onPropertyAward(property?._id);
      })
      .catch((err) => {})
      .finally(() => {
        setLoading(false);
      });
    // setDetailsShow(false);
    // setAwardPopupModal(true);
    // if (selectedTenant.length == 1) {
    //   navigate(
    //     `/assignProperty/${property?._id}?sharedProfile=${selectedTenant[0]?._id}&step=0`
    //   );
    // } else {
    // }
  };

  const sendAwardPropEmail = async () => {
    const send_data = {
      selected_tenants: selectedTenant.map((val) => val?.tenantid),
      property_id: property?._id,
    };

    try {
      const res = await multiPropAward(send_data);
      toast.success(
        _t(
          "successWhileAwardingMultiPropAdminWillContactYou",
          "Success text when LL tries to award Multi tenant prop"
        )
      );
      return res.data;
    } catch (err) {
      toast.error(
        _t(
          "errorWhileAwardingMultiProp",
          "Error text when LL tries to award Multi tenant prop"
        )
      );
      console.log("Error while awarding MultiProp");
      return Error(err);
    }
  };

  const sendInvitationViaEmail = async (e) => {
    e.preventDefault();
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(sharerEmail)) {
      setSendInvitationLoading(true);
      try {
        const response = await sendInvitationToTenant({
          type: "email",
          name: sharerName,
          email: sharerEmail,
          property_id: property?._id,
        });
        const data = response.data;
        if (data.message) {
          toast.success(data.message);
        }
      } catch (error) {
        const response = error.response;
        if (response.data) {
          if (response.data.err) {
            toast.error(response.data.err);
          }
        }
      } finally {
        setSharerEmail(null);
        setShowEmailModal(false);
        setSendInvitationLoading(false);
      }
    } else {
      toast.error(_t("invalidEmailAddress"));
      return false;
    }
  };

  const getName = () => {
    if (haveValue(searchText)) {
      return (tanentData ?? []).filter((item) =>
        item?.label?.toLowerCase().includes(searchText?.toLowerCase())
      );
    } else if (isPropertyAwarded) {
      return propertyAwardedSelectedTenant;
    } else {
      return propertyShareProfiles;
    }
  };

  const handleCheckboxChange = (tenantData) => (e) => {
    const isChecked = e.target.checked;
    setSelectedTenant((prev) => {
      if (isChecked) {
        return [...prev, tenantData];
      } else {
        return prev.filter((tenant) => tenant._id !== tenantData._id);
      }
    });
  };

  const handleTenantSelect = async (tenantData, selectStatus) => {
    // Add tenant ID to linking array
    setLinkingTenantIds((prev) => [...prev, tenantData.value]);

    try {
      const updatedList =
        selectStatus === "notSelected"
          ? [...selectedTanents, tenantData.value]
          : selectedTanents.filter((val) => val !== tenantData.value);

      // update internal state also

      setSelectedTanents(updatedList);
      await handleSaveChanges(null, updatedList);
      await fetchShareProfileData(false, false);
    } catch (error) {
      console.error("Error linking/unlinking tenant:", error);
    } finally {
      // Remove tenant ID from linking array
      setLinkingTenantIds((prev) =>
        prev.filter((id) => id !== tenantData.value)
      );
    }
  };

  const handleUnLinkSingle = async (e, tenantData) => {
    const tenantId = tenantData?.tenantid?._id;

    // Add tenant ID to unlinking array
    setUnlinkingTenantIds((prev) => [...prev, tenantId]);

    try {
      const temp = selectedTanents.filter((val) => val !== tenantId);

      setSelectedTanents(temp);
      await handleSaveChanges(e, temp);
      await fetchShareProfileData(false, true);
    } catch (error) {
      console.error("Error unlinking tenant:", error);
      toast.error(
        _t("errorWhileUnlinkingTenant", "Error while unlinking tenant")
      );
    } finally {
      // Remove tenant ID from unlinking array
      setUnlinkingTenantIds((prev) => prev.filter((id) => id !== tenantId));
    }
  };

  const handleUnAwardProperty = () => {
    setLoading(true);
    const send_data = {
      property_id: property?._id,
    };
    multiPropUnAward(send_data)
      .then((res) => {
        onPropertyAward(property?._id);
        setShowUnAwardSuccessPopup(true);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleOpenProfile = async (profile) => {
    setLoading(true);
    try {
      const checkView = await shouldDeductNextView(user, profile?._id);

      if (checkView) {
        setCurrentProfile(profile);
        setServingPromptModal(true);
      } else {
        const params = new URLSearchParams(window.location.search);
        params.set("propertyId", property?._id);

        const propertyName = formatPropertyAddress(property, currentLang);

        params.set("propName", propertyName);
        const updatedUrl = `/${workspaceId}/home?${params.toString()}`;
        window.history.replaceState(null, "", updatedUrl);

        navigate(
          `/${workspaceId}/profile-property?sharedprofileid=${profile?._id}`,
          {
            state: { from: updatedUrl },
          }
        );
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const areAllSelectedTenantsInsurable = useMemo(() => {
    const tenantsForInsurance = isPropertyAwarded
      ? propertyAwardedSelectedTenant
      : selectedTenant;
    if (!tenantsForInsurance || tenantsForInsurance.length === 0) {
      return false;
    }

    return tenantsForInsurance.every((tenant) => {
      const experianData =
        tenant?.tenantid?.tenant_extra_field_id?.experianJson?.["s:Envelope"]?.[
          "s:Body"
        ]?.GenerarInformeResponse?.GenerarInformeResult?.InformeDelphi4A3;

      return !isDefaulter(experianData);
    });
  }, [selectedTenant, propertyAwardedSelectedTenant, isPropertyAwarded]);

  const areAllSelectedTenantsHaveClearedAmlChecks = useMemo(() => {
    if (!selectedTenant || selectedTenant.length === 0) {
      return false;
    }

    return selectedTenant.some((tenant) => {
      if (
        !haveValue(
          tenant?.tenantid?.onfido_user_kyc?.onfido_workflow_res?.object?.status
        )
      ) {
        return false;
      }
      return !amlKycChecks(tenant?.tenantid);
    });
  }, [selectedTenant]);

  const getStatusStyle = () => {
    let finalStatus = null;
    console.log("STAUTS STYLE CALLED");
    if (selectedTenant?.length === 0) {
      finalStatus = STATUS_STYLES.grey;
    }
    if (!areAllSelectedTenantsInsurable) {
      finalStatus = STATUS_STYLES.red;
    }
    if (areAllSelectedTenantsHaveClearedAmlChecks) {
      finalStatus = STATUS_STYLES.yellow;
    }
    {
      finalStatus = STATUS_STYLES.green;
    }
    setStatusStyle(finalStatus);
  };

  const checkInsuranceDocument = async () => {
    try {
      setCheckStatusLoading(true);
      const docStatusResponse = await checkInsuranceDocumentStatus(
        property?._id
      );

      if (haveValue(docStatusResponse?.policyDocument)) {
        await loadData();
        toast.success(_t("policyIsAvailableToDownlaod"));
      } else {
        toast.success(_t("insuranceIsInProcessPleaseWait"));
      }
    } catch (error) {
      toast.error(_t("failedToLoadStatus"));
    } finally {
      setCheckStatusLoading(false);
    }
  };

  const isInsurable = user?.insurance_service_status;
  // Insurance Handler starts
  const runInsuranceSimulationHandler = async () => {
    const errors = [];

    try {
      setSimulationLoading(true);

      if (!property?.province) errors.push(_t("provinceIsRequired"));
      if (!property?.muncipality) errors.push(_t("municipalityIsRequired"));
      if (!property?.postcode) errors.push(_t("postcodeIsRequired"));
      if (!property?.street) errors.push(_t("streetNameIsRequired"));
      if (!property?.street_number) errors.push(_t("streetNumberIsRequired"));

      const tenantIds = selectedTenant
        .map((t) => t?.tenantid?._id)
        .filter(Boolean);

      const checkConsentResponse = await checkMutuaConsents(tenantIds);
      if (checkConsentResponse?.missingConsent?.length) {
        errors.push(
          ...checkConsentResponse.missingConsent.map(
            (t) => `${t.name} ${_t("hasMissingGrupoMutuaConsent")}`
          )
        );
      }

      if (errors.length > 0) {
        setInsuranceSimulationErrorModal(true);
        setInsuranceSimulationErrors(errors);
        setSimulationLoading(false);
        return;
      }

      const payload = {
        propertyId: property?._id,
        property_rent: rent,
        lease_start_date: moment().format("DD/MM/YYYY"),
        policy_start_date: moment().format("DD/MM/YYYY"),
        selected_tenants: selectedTenant.map((t) => t?.tenantid?._id),
      };
      const simulationResponse = await runInsuranceSimulation(payload);

      if (simulationResponse?.success_res?.isInsurable) {
        setInsuracePopupModal(true);
      } else {
        setShowInsuranceReviewModal(true);
      }
    } catch (error) {
      console.log("Failed in runInsuranceSimulation", error);
      toast.error(_t("failedToRunInsuranceSimulation"));
    } finally {
      setSimulationLoading(false);
    }
  };
  // Insurance Handler ends

  const renderFinalResult = () => {
    const DECISION_THRESHOLD = customPolicyDetails.threshold;

    const values = Object.values(tenantResults || {});

    // 1️⃣ Check for business error
    const errorMessage = [
      ...new Set(
        values
          .filter((item) => item?.isHardFail)
          .flatMap((item) => item?.errorEntries || [])
          .map((entry) => entry[1]?.label)
          .filter(Boolean)
      ),
    ].join(",");

    if (errorMessage) {
      return `Error: ${errorMessage}`;
    }

    // 2️⃣ Extract valid final scores
    const scores = values
      .map((item) => item?.data?.finalScore ?? item?.finalScore)
      .filter((score) => typeof score === "number");

    if (!scores.length) return "No Valid Scores";

    // 3️⃣ Get lowest score
    // const lowestScore = Math.min(...scores);

    // 3️⃣ Get lowest pillar values
    const weightObj = Object.values(tenantResults).reduce((acc, item) => {
      if (!item || !item.pillars) return acc;

      Object.entries(item.pillars).forEach(([key, value]) => {
        acc[key] = acc[key] !== undefined ? Math.min(acc[key], value) : value;
      });

      return acc;
    }, {});

    // 4️⃣ Calculate weighted result using policyConfig.pillarWeights
    const result = Object.entries(weightObj).reduce((sum, [key, value]) => {
      const weight = customPolicyDetails?.policyConfig?.pillarWeights[key] || 0;
      return sum + value * weight;
    }, 0);

    // Decision Logic
    let verdict;

    if (result < DECISION_THRESHOLD.MIN) {
      verdict = "Rejected";
    } else if (result > DECISION_THRESHOLD.MAX) {
      verdict = "Approved";
    } else {
      verdict = "Conditional";
    }

    // 5️⃣ Final output
    return (
      <>
        <div>Lowest Score: {result.toFixed(2)}</div>
        {verdict == "Conditional" && (
          <div>
            <input
              type="checkbox"
              onClick={(e) => setGiveInsurance(e.target.checked)}
              checked={giveInsurance}
            />
            Give Insurance
          </div>
        )}
        <div>Verdict: {verdict}</div>
      </>
    );
  };

  const renderIndividualDeaResult = (id) => {
    if (haveValue(id)) {
      const data = allDeaResult?.[id];
      const profilesHaveMissingDocs = data?.vals?.DOCUMENTATION > 0;

      const hasHardFailEntries =
        data?.errorEntries?.filter(([key]) => key !== "EFFORT_RATE_SCORE")
          ?.length > 0;

      // ✅ NEW (safe optional checks)
      const guarantors = data?.guarantors || [];

      const guarantorHasHardFail = guarantors.some(
        (g) =>
          g?.errorEntries?.filter(([key]) => key !== "EFFORT_RATE_SCORE")
            ?.length > 0
      );

      const guarantorMissingDocs = guarantors.some(
        (g) => g?.vals?.DOCUMENTATION > 0
      );

      // 🔴 unchanged logic + guarantor extension
      if (hasHardFailEntries || guarantorHasHardFail) {
        return STATUS_STYLES.red;
      } else if (!profilesHaveMissingDocs && !guarantorMissingDocs) {
        return STATUS_STYLES.green;
      } else {
        return STATUS_STYLES.yellow;
      }
    }
  };

  return (
    <>
      {detailsShow && (
        <div
          className="metermodal modal-xl wrapper-modal modalWidth_set"
          onClick={() => {
            setDetailsShow(false);
            if (setPropData) setPropData({});
            // setSelectedTenant([]);
          }}
        >
          <div
            className={`doc-history-popup rental-overview-popup total-salary-modal share-profile-modal sharedTenantProfileModal ${
              detailsShow ? "open" : ""
            }`}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="doc-history-header linked-property-popup-padding">
              <div className="d-flex align-items-center custom-gap-2">
                <img
                  src={CloseIcon}
                  alt=""
                  className="doc-history-close-btn"
                  onClick={() => {
                    setDetailsShow(false);
                    if (setPropData) setPropData({});
                    // setSelectedTenant([]);
                  }}
                />
                <h4 className="custom-modal-heading">{_t("rentalOverview")}</h4>
              </div>
            </div>
            <div className="rental-overview-scroll">
              <div className="assigned_details_body">
                <p className="linked_p_details linked-property-sub-heading">
                  {_t("propertyTitle")}
                </p>
              </div>
              <div className="d-flex justify-content-between align-items-center gap-2 header-linked-prop">
                <div className="d-flex justify-content-between assigned_details_modal mb-0">
                  <div className="rental-overview-home-info">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M10.7068 0.29279L19.7051 9.29291C20.335 9.92291 19.889 10.9999 18.9982 10.9999H17.9984V16.9999C17.9984 17.7956 17.6824 18.5587 17.1199 19.1213C16.5574 19.6839 15.7945 20 14.9989 20H13.9992V12.9999C13.9992 12.2347 13.7069 11.4984 13.182 10.9416C12.6572 10.3849 11.9394 10.0498 11.1756 10.0049L10.9997 9.99988H9.00005C8.20458 9.99988 7.44164 10.3159 6.87917 10.8786C6.31664 11.4412 6.00064 12.2042 6.00064 12.9999V20H5.00082C4.20531 20 3.4424 19.6839 2.87989 19.1213C2.31739 18.5587 2.00137 17.7956 2.00137 16.9999V10.9999H1.00156C0.111727 10.9999 -0.33519 9.92291 0.294693 9.29291L9.29299 0.29279C9.48052 0.105316 9.73476 0 9.99987 0C10.265 0 10.5193 0.105316 10.7068 0.29279ZM10.9997 11.9999C11.2649 11.9999 11.5192 12.1053 11.7067 12.2928C11.8942 12.4804 11.9995 12.7347 11.9995 12.9999V20H8.00029V12.9999C8.00029 12.755 8.09017 12.5186 8.25293 12.3356C8.41564 12.1525 8.63988 12.0356 8.88311 12.0069L9.00005 11.9999H10.9997Z"
                        fill="#253837"
                      />
                    </svg>
                    <div className="">
                      <p style={{ margin: "0" }} className="assigned_address">
                        {formatPropertyAddress(property, currentLang)}
                      </p>
                      <div className="d-flex align-items-center gap-1">
                        <p>{property?.province ?? ""},</p>
                        <p>{property?.postcode ?? ""}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="property-rent-field rental-overview-input-field">
                  <div
                    className={`property-rent-field-input ${
                      propertyRentError ? "property-validation-error" : ""
                    }`}
                  >
                    <span>{_t("propertyRent")}:</span>{" "}
                    <span style={{ fontWeight: "700", color: "#253837" }}>
                      €
                    </span>
                    <input
                      style={{ border: "0" }}
                      placeholder="0"
                      type="number"
                      value={rent}
                      disabled={isPropertyAwarded}
                      onChange={handleChangeRent}
                      onBlur={handleBlurRent}
                    />
                    <span>/mo</span>
                  </div>
                  {propertyRentError && (
                    <p className="error-message">
                      {_t("pleaseEnterTheRentToProceed")}
                    </p>
                  )}
                </div>
              </div>
              <div className="assigned_details_body">
                <p className="linked_p_details linked-property-sub-heading">
                  {_t("tenants")}
                </p>
              </div>
              {isInsuranceEnabledWorkspace &&
                isPropertyAwarded &&
                (haveValue(property?.insurance_data?.policy_document) ? (
                  <div
                    className="non-payment-container cursor-pointer"
                    onClick={() => {
                      if (property?.insurance_data?.policy_document) {
                        window.open(
                          `${process.env.REACT_APP_CDN_ENDPOINT}/${process.env.REACT_APP_CDN_CONTAINER}/${property.insurance_data.policy_document}`,
                          "_blank"
                        );
                      }
                    }}
                  >
                    <div className="non-payment-container-info">
                      <img src={"/images/non-payment-insurance.svg"} alt="" />
                      <div>
                        <h1>{_t("downloadInsurancePolicy")}</h1>
                        <p>{_t("nonPaymentInsuranceForThisRental")}</p>
                      </div>
                    </div>
                    <img
                      className="arrow-right cursor-pointer"
                      src={DownloadIcon}
                      alt=""
                    />
                  </div>
                ) : (
                  <div className="non-payment-container">
                    <div className="non-payment-container-info">
                      <img src={"/images/non-payment-insurance.svg"} alt="" />
                      <div>
                        <h1>{_t("processingInsurance")}</h1>
                        <p>{_t("nonPaymentInsuranceForThisRental")}</p>
                      </div>
                    </div>
                    <button
                      onClick={checkInsuranceDocument}
                      disabled={checkStatusLoading}
                      className="btnNext addGuarantorButton check-status-btn"
                    >
                      {_t(
                        checkStatusLoading ? "checkingStatus" : "checkStatus"
                      )}
                    </button>
                  </div>
                ))}
              {isInsuranceEnabledWorkspace &&
                selectedTenant.length > 0 &&
                WORKSPACE_ROLES_CAPABILITIES?.properties?.purchaseInsurance?.includes(
                  user?.current_workspace_role
                ) &&
                (areAllSelectedTenantsInsurable ? (
                  <div
                    className="non-payment-container cursor-pointer"
                    onClick={() => {
                      if (
                        simulationLoading ||
                        !areAllSelectedTenantsInsurable ||
                        !WORKSPACE_ROLES_CAPABILITIES?.properties?.purchaseInsurance?.includes(
                          user?.current_workspace_role
                        )
                      ) {
                        console.log("Not allowed");
                      } else {
                        if (!haveValue(rent)) {
                          setPropertyRentError(true);
                        } else {
                          runInsuranceSimulationHandler();
                        }
                      }
                    }}
                  >
                    <div className="non-payment-container-info">
                      <img src={"/images/non-payment-insurance.svg"} alt="" />
                      <div>
                        <h1>
                          {_t(
                            simulationLoading
                              ? "analysingFeasibility"
                              : "getNonPaymentInsurance"
                          )}
                        </h1>
                        {!simulationLoading && (
                          <p>{_t("protectYourRentAgainstDefaultingTenants")}</p>
                        )}
                        <span>
                          <a
                            href="/pdf/Mom_seguroimpagoalquiler.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                          >
                            {_t("insurancePolicy")}
                          </a>
                        </span>
                      </div>
                    </div>
                    <img
                      className="arrow-right cursor-pointer"
                      src={
                        simulationLoading
                          ? SkorDefaultLoader
                          : "/images/arrow-right.svg"
                      }
                      alt=""
                    />
                  </div>
                ) : (
                  <div
                    style={{ borderColor: "#EEEEF3", backgroundColor: "white" }}
                    className="non-payment-container"
                  >
                    <div className="non-payment-container-info">
                      <img src={"/images/insurance-not.svg"} alt="" />
                      <div>
                        <h1 style={{ color: "#7F7F7F" }}>
                          {_t("insuranceNotAvailable")}
                        </h1>
                        <p>{_t("someSelectedTenantsAreNotInsurable")}</p>
                      </div>
                    </div>
                  </div>
                ))}
              {!isPropertyAwarded && (
                <div className="profile-page marless tab-profile-search-header w-100">
                  <div className="Search-bar searchbar_cls w-100 d-flex justify-content-between align-items-center">
                    {WORKSPACE_ROLES_CAPABILITIES?.properties?.linkTenant?.includes(
                      user?.current_workspace_role
                    ) && (
                      <div className="search_bar_edit">
                        <a href="#">
                          <img src={"/images/search-icon-grey.svg"} alt="" />
                        </a>
                        <input
                          type="text"
                          className="custom-input mb-0 input01"
                          value={searchText}
                          placeholder={_t("searchTenants")}
                          onChange={(e) => {
                            // if (e.target.value.trim() === "") {
                            //   setSelectedTenantsForLink([]);
                            // }
                            setSearchText(e.target.value);
                          }}
                          disabled={isPropertyAwarded}
                        />
                        {haveValue(searchText) ? (
                          <img
                            src={Cancelimg}
                            alt="icon"
                            onClick={() => {
                              // setSelectedTenantsForLink([]);
                              setSearchText("");
                            }}
                            className="canceicon topRightIcon searchCrossIcon"
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    )}
                    {WORKSPACE_ROLES_CAPABILITIES?.properties?.linkTenant?.includes(
                      user?.current_workspace_role
                    ) && (
                      <button
                        className="addGuarantorButton d-flex mx-0 btnNext d-flex jusitfy-content-center align-items-center"
                        onClick={(e) => {
                          setShowEmailModal(true);
                          // setDetailsShow(false);
                        }}
                        disabled={isPropertyAwarded}
                      >
                        <img src="/images/add-white.svg" />
                        {_t("inviteTenant")}
                      </button>
                    )}
                    {isPropertyAwarded && <ButtonActionTooltip />}
                  </div>
                </div>
              )}

              {saveTanentLoading ? (
                <Loader />
              ) : (
                <>
                  {/* <div className="result-box">{renderFinalResult()}</div> */}

                  <div className="mobile-single-property">
                    <ul>
                      {getName()?.length > 0 ? (
                        getName()?.map((assignPropData) => {
                          const tenantId =
                            assignPropData?.tenantid?._id ||
                            assignPropData?.value;
                          const isLinking = linkingTenantIds.includes(tenantId);
                          const isUnlinking =
                            unlinkingTenantIds.includes(tenantId);
                          const isProcessing = isLinking || isUnlinking;

                          return (
                            <li className="d-flex listWrapper linked_li_details linked_li_details2">
                              <div className="d-flex w-100 justify-content-between align-items-center">
                                <div className="linked_li_div d-flex align-items-center justify-content-center custom-gap-2">
                                  {!haveValue(searchText) && (
                                    <div
                                      className={`checkboxWrapper d-flex align-items-center justify-content-center ${
                                        isPropertyAwarded ||
                                        !WORKSPACE_ROLES_CAPABILITIES?.tenantManagement?.includes(
                                          user?.current_workspace_role
                                        )
                                          ? "checkboxWrapperDisabled"
                                          : ""
                                      }`}
                                    >
                                      <label className="custom-gap-3 custom-checkbox mb-0">
                                        <input
                                          type={`checkbox`}
                                          checked={selectedTenant.includes(
                                            assignPropData
                                          )}
                                          onChange={handleCheckboxChange(
                                            assignPropData
                                          )}
                                          disabled={
                                            isPropertyAwarded ||
                                            !WORKSPACE_ROLES_CAPABILITIES?.tenantManagement?.includes(
                                              user?.current_workspace_role
                                            )
                                          }
                                        />
                                        <span
                                          className={`custom-checkmark`}
                                        ></span>
                                      </label>
                                    </div>
                                  )}
                                  <div className="earner-thumbnail-wrapper d-flex align-items-center justify-content-center">
                                    <img src={UserIcon} />
                                  </div>
                                  <div>
                                    {searchText ? (
                                      <p className="linked_li_name d-flex gap-2 align-items-center cursor-pointer">
                                        {assignPropData?.label}
                                      </p>
                                    ) : (
                                      <>
                                        <p
                                          onClick={() =>
                                            handleOpenProfile(assignPropData)
                                          }
                                          className="linked_li_name d-flex gap-2 align-items-center cursor-pointer"
                                        >
                                          {getUserDisplayName(
                                            assignPropData?.tenantid
                                          )}
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="7"
                                            height="11"
                                            viewBox="0 0 8 13"
                                            fill="none"
                                            className="arrow-icon"
                                          >
                                            <path
                                              d="M1 12L7 6.5L1 1"
                                              stroke="#253837"
                                              stroke-width="1.4"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            />
                                          </svg>
                                          {/* {haveValue(
                                            tenantResults[assignPropData?._id]
                                              ?.finalScore
                                          ) ? (
                                            tenantResults[assignPropData?._id]
                                              ?.finalScore
                                          ) : (
                                            <p className="text-danger">
                                              {
                                                tenantResults[
                                                  assignPropData?._id
                                                ]?.errorMsg
                                              }
                                            </p>
                                          )} */}
                                        </p>
                                        <div className="d-flex align-items-center justify-content-start custom-gap-3 score-text-property-margin">
                                          {user?.current_workspace
                                            ?.dea_rules_activated &&
                                          deaWorkspace ? (
                                            haveValue(
                                              allDeaResult?.[
                                                assignPropData?._id
                                              ]
                                            ) ? (
                                              (() => {
                                                const result =
                                                  renderIndividualDeaResult(
                                                    assignPropData?._id
                                                  );
                                                return (
                                                  <>
                                                    <p
                                                      className="deaIndividualStatus d-flex align-items-center custom-gap-2"
                                                      style={{
                                                        background:
                                                          result.backgroundColor,
                                                        // border: result.border,
                                                        color: result.color,
                                                        fontWeight: result.fw,
                                                      }}
                                                    >
                                                      <img src={result.img} />
                                                      {result.deaIndividualText}
                                                    </p>
                                                    <span className="deaIndividualIncome">
                                                      •
                                                    </span>
                                                    <p className="deaIndividualIncome">
                                                      {(() => {
                                                        const tInfo =
                                                          assignPropData?.tenantid;
                                                        return (
                                                          getCustomIncomeDetails(
                                                            tInfo,
                                                            user,
                                                            _t,
                                                            assignPropData
                                                              ?.income_selection
                                                              ?.tenant_source,
                                                            undefined,
                                                            undefined,
                                                            deaWorkspace
                                                          )?.amount ?? 0
                                                        );
                                                      })()}{" "}
                                                      €{"/"}
                                                      {_t("mo")}
                                                    </p>
                                                  </>
                                                );
                                              })()
                                            ) : !isPropertyAwarded ? (
                                              <Loader />
                                            ) : null
                                          ) : (
                                            <>
                                              <p className="linked_li_score scoreTextProperty scoreTextDivider">
                                                {_t("profile")}:{" "}
                                                {assignPropData?.tenantid
                                                  ?.paymentScores?.creditScore
                                                  ?.value || 0}
                                              </p>
                                              <p
                                                className={`scoreTextProperty ${
                                                  isInsurable
                                                    ? "scoreTextDivider"
                                                    : ""
                                                }`}
                                              >
                                                {_t("maxRent")}:{" "}
                                                {calculateRentAmount(
                                                  assignPropData
                                                )}
                                                {"% "}
                                              </p>
                                              {
                                                isInsurable &&
                                                  (() => {
                                                    const defaulter =
                                                      isDefaulter(
                                                        assignPropData?.tenantid
                                                          ?.tenant_extra_field_id
                                                          ?.experianJson?.[
                                                          "s:Envelope"
                                                        ]?.["s:Body"]
                                                          ?.GenerarInformeResponse
                                                          ?.GenerarInformeResult
                                                          ?.InformeDelphi4A3
                                                      );
                                                    return (
                                                      <p
                                                        className={`recentText ${
                                                          !defaulter
                                                            ? "insurable-dot"
                                                            : "not-insurable-dot"
                                                        }`}
                                                      >
                                                        {!defaulter
                                                          ? _t("insurable")
                                                          : _t("notInsurable")}
                                                      </p>
                                                    );
                                                  })()
                                                // <p className="scoreTextProperty custom-gap-2 d-flex align-items-center">
                                              }
                                            </>
                                          )}
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                                {WORKSPACE_ROLES_CAPABILITIES?.properties?.linkTenant?.includes(
                                  user?.current_workspace_role
                                ) && (
                                  <div className="share-it">
                                    {searchText &&
                                    !selectedTanents.some(
                                      (val) => val === assignPropData?.value
                                    ) ? (
                                      <Link
                                        className="share-btn shareBtnModal"
                                        onClick={() => {
                                          if (!isLinking) {
                                            handleTenantSelect(
                                              assignPropData,
                                              "notSelected"
                                            );
                                          }
                                        }}
                                      >
                                        <img
                                          src="/images/share-icon.svg"
                                          alt=""
                                        />
                                        {isLinking
                                          ? `${_t("unlinking")}...`
                                          : _t("link")}
                                      </Link>
                                    ) : searchText ? (
                                      <Link
                                        className="share-btn shareBtnModal selected"
                                        onClick={() => {
                                          if (!isLinking) {
                                            handleTenantSelect(
                                              assignPropData,
                                              "selected"
                                            );
                                          }
                                        }}
                                      >
                                        {isLinking
                                          ? `${_t("linking")}...`
                                          : _t("unLink")}
                                      </Link>
                                    ) : (
                                      <button
                                        className="share-btn btnNext"
                                        onClick={(e) => {
                                          if (!isUnlinking) {
                                            handleUnLinkSingle(
                                              e,
                                              assignPropData
                                            );
                                          }
                                        }}
                                        disabled={isPropertyAwarded}
                                      >
                                        {isUnlinking
                                          ? `${_t("unlinking")}...`
                                          : _t("unLink")}
                                      </button>
                                    )}
                                  </div>
                                )}
                              </div>
                            </li>
                          );
                        })
                      ) : (
                        <p className="notSharedText text-center">
                          {_t("noDataFound")}
                        </p>
                      )}
                    </ul>
                  </div>
                  {/* {isInsurable && selectedTenant?.length > 0 && (
                    <div className="doc-history-content doc-history-content-insurance">
                      <div className="d-flex align-items-center custom-gap-3 justify-content-between header-wrapper-insurance">
                        <h4>{_t("rentalInsurance")}</h4>
                        <div className="optional-insurance">
                          {_t("optional")}
                        </div>
                      </div>

                      <div
                        style={{ flexWrap: "nowrap" }}
                        className="d-flex align-items-start custom-gap-2"
                      >
                        <div
                          className="checkmarkWrapper"
                          style={{
                            background: areAllSelectedTenantsInsurable
                              ? "transparent"
                              : "#FFE2E2",
                          }}
                        >
                          <img
                            className="commonClassImage"
                            src={
                              areAllSelectedTenantsInsurable
                                ? "/images/checkmark-grey.svg"
                                : notIcon
                            }
                            alt="checkmark-icon"
                          />
                        </div>
                        <div className="d-flex flex-column custom-gap-2">
                          {areAllSelectedTenantsInsurable ? (
                            <p>
                              {_t(
                                "allSelectedTenantsAreEligibleInsuranceWillApplyToAllOfThemIfPurchased"
                              )}
                            </p>
                          ) : (
                            <p>
                              {_t(
                                "someTenantsReuireAManualReviewBeforeRequestingTheInsurance"
                              )}
                            </p>
                          )}
                          <a
                            href="/pdf/Mom_seguroimpagoalquiler.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {_t("insurancePolicy")}
                          </a>
                        </div>
                      </div>
                      <div>
                        <button
                          onClick={() => {
                            if (
                              !areAllSelectedTenantsInsurable ||
                              !WORKSPACE_ROLES_CAPABILITIES?.properties?.purchaseInsurance?.includes(
                                user?.current_workspace_role
                              )
                            ) {
                              console.log("Not allowed");
                            } else {
                              setInsuracePopupModal(true);
                            }
                          }}
                          className="addGuarantorButton d-flex mx-0 btnNext purchaseInsuranceButton d-flex jusitfy-content-center align-items-center"
                          disabled={
                            !areAllSelectedTenantsInsurable ||
                            !WORKSPACE_ROLES_CAPABILITIES?.properties?.purchaseInsurance?.includes(
                              user?.current_workspace_role
                            )
                          }
                        >
                          {_t("requestInsurance")}
                        </button>
                      </div>
                    </div>
                  )} */}
                </>
              )}
            </div>
            {saveTanentLoading ? (
              ""
            ) : (
              <>
                <div className="linked-property-popup-padding">
                  <div className="chat-with-sopport-bottom-fixed">
                    {isPropertyAwarded &&
                      haveValue(property?.insurance_payment_date) &&
                      (moment().diff(
                        moment(property.insurance_payment_date),
                        "hours"
                      ) <= 24 ? (
                        // CASE 1: Insurance date within 24 hours
                        <div className="doc-history-content doc-history-content-insurance doc-history-within-24hrs">
                          <div className="d-flex align-items-center custom-gap-3 justify-content-between header-wrapper-insurance">
                            <h4>{_t("processingInsurance")}</h4>
                            <div className="optional-insurance">
                              {_t("optional")}
                            </div>
                          </div>

                          <div className="d-flex align-items-start custom-gap-2">
                            <IoStopwatchOutline className="commonClassImage" />
                            <div className="d-flex flex-column custom-gap-2">
                              <p>
                                {_t(
                                  "yourInsuraceIseingProcessedAndWillBeSentToYourEmailWithinTwentyFourHours"
                                )}
                              </p>
                              <a
                                href="/pdf/Mom_seguroimpagoalquiler.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {_t("insurancePolicy")}
                              </a>
                            </div>
                          </div>
                        </div>
                      ) : (
                        // CASE 2: Older than 24 hours
                        <div className="doc-history-content">
                          <p>
                            {_t(
                              "yourInsuranceWasSuccessfullyProcessedAndNextStepsWereSentToYourEmailInCaseOfAnyQuestionsPleaseContactOurSupportChat"
                            )}
                          </p>
                          <a href="https://wa.me/34617662602" target="_blank">
                            {_t("chatWithSupport")}
                          </a>
                        </div>
                      ))}
                  </div>
                </div>
                <div
                  className="rental-overview-footer"
                  style={{
                    borderTop: !isPropertyAwarded
                      ? statusStyle.border
                      : "2px solid #DAECC8",
                    backgroundColor: !isPropertyAwarded
                      ? statusStyle.backgroundColor
                      : "#F2FBE9",
                  }}
                >
                  {WORKSPACE_ROLES_CAPABILITIES?.propertyManagement?.includes(
                    user?.current_workspace_role
                  ) && (
                    <div className="buttonset_css d-flex align-items-center justify-content-between gap-4">
                      {resultLoader ? (
                        <img
                          src={SkorDefaultLoader}
                          className="defaultSkorLoader"
                          alt="Example"
                        />
                      ) : (
                        <>
                          {!isPropertyAwarded ? (
                            <span
                              style={{
                                color: statusStyle.color,
                                fontWeight: statusStyle.fw,
                              }}
                            >
                              {statusStyle.img && (
                                <img src={statusStyle.img} alt="" />
                              )}
                              {statusStyle.text}
                            </span>
                          ) : (
                            <span
                              style={{ color: "#82CF3F", fontWeight: "600" }}
                            >
                              <img src={"/images/awarded.svg"} alt="" />
                              {_t("awarded")}
                            </span>
                          )}
                          <div className="d-flex align-items-center justify-content-between custom-gap-2">
                            {WORKSPACE_ROLES_CAPABILITIES?.tenants?.generateReport?.includes(
                              user?.current_workspace_role
                            ) && (
                              <button
                                onClick={() => {
                                  setAwardPopupModal(true);
                                }}
                                disabled={
                                  selectedTenant.length === 0 &&
                                  !isPropertyAwarded
                                }
                                type="button"
                                className="btnNext rental-overview-white-button commonButtonPropertyDark commonButtonPropertyLight"
                              >
                                {_t("generateReport")}
                              </button>
                            )}
                            {!isPropertyAwarded &&
                              WORKSPACE_ROLES_CAPABILITIES?.properties?.award?.includes(
                                user?.current_workspace_role
                              ) && (
                                <button
                                  style={{
                                    backgroundColor: statusStyle.color,
                                  }}
                                  onClick={() => {
                                    if (selectedTenant.length !== 0) {
                                      handleAwardPropFlow();
                                    }
                                  }}
                                  type="button"
                                  disabled={selectedTenant.length === 0}
                                  className="btnNext commonButtonPropertyDark"
                                >
                                  {_t("awardProperty")}
                                </button>
                              )}
                            {isPropertyAwarded &&
                            WORKSPACE_ROLES_CAPABILITIES?.properties?.award?.includes(
                              user?.current_workspace_role
                            ) ? (
                              <button
                                onClick={handleUnAwardProperty}
                                className="commonButtonPropertyDark commonButtonPropertyLight"
                                style={{
                                  background: "#d74142",
                                  color: "#fff",
                                }}
                              >
                                {_t("unAwardProperty")}
                              </button>
                            ) : (
                              ""
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      )}

      <AwardPropertyPopup
        awardPopupModal={awardPopupModal}
        setAwardPopupModal={setAwardPopupModal}
        selectedTenants={
          isPropertyAwarded ? propertyAwardedSelectedTenant : selectedTenant
        }
        property={property}
        rentVal={rent}
        currentLang={currentLang}
      />
      <PurchaseInsurancePopup
        insuracePopupModal={insuracePopupModal}
        setInsuracePopupModal={setInsuracePopupModal}
        selectedTenants={
          isPropertyAwarded ? propertyAwardedSelectedTenant : selectedTenant
        }
        property={property}
        rent={rent}
      />

      <Modal
        show={showEmailModal}
        onHide={(e) => setShowEmailModal(false)}
        centered
        className="newmodalui wrapper-modal inviteTenantModal max-w-lg"
      >
        <Modal.Header>
          <Modal.Title>{_t("inviteTenant")}</Modal.Title>
          <div
            className="cursor-pointer"
            onClick={() => setShowEmailModal(false)}
          >
            <img
              src={Cancelimg}
              alt="icon"
              className="canceicon topRightIcon"
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="qr-link-copi"> */}
          <form
            onSubmit={sendInvitationViaEmail}
            className="d-flex flex-wrap justify-content-between"
          >
            <div className="form-group customInput col-6 bodyContentset">
              <label>{_t("name")}</label>
              <input
                type="text"
                onChange={(e) => {
                  setSharerName(e.target.value);
                }}
                className="form-control"
                required={true}
                placeholder={_t("enterName")}
                onBeforeInput={(e) => {
                  const isValidChar = /^[A-Za-zÀ-ÿ\s'-]+$/.test(e.data);
                  if (!isValidChar) e.preventDefault();
                }}
              />
            </div>
            <div className="form-group customInput col-6 bodyContentset">
              <label>{_t("email")}</label>
              <input
                type="email"
                onChange={(e) => {
                  setSharerEmail(e.target.value);
                }}
                className="form-control"
                required={true}
                placeholder={_t("enterEmail")}
                onBeforeInput={(e) => {
                  if (!e.data) return; // allow delete, etc.

                  const value = e.data;

                  // Allow full pasted string
                  const isValid = /^[a-z0-9._%+-@]+$/.test(value);

                  if (!isValid) {
                    e.preventDefault();
                    return;
                  }

                  // Prevent multiple @ (handle paste too)
                  const existingValue = e.target.value;
                  const totalAtCount =
                    (existingValue + value).split("@").length - 1;

                  if (totalAtCount > 1) {
                    e.preventDefault();
                  }
                }}
              />
            </div>
            <div className="col-12 mt-3  d-flex justify-content-center">
              <button
                type="submit"
                className="btnNext commonButtonPropertyDark"
                disabled={sendInvitationLoading}
              >
                {_t("sendInvite")}
              </button>
            </div>
          </form>
          {/* </div> */}
        </Modal.Body>
      </Modal>
      <Modal
        show={showUnAwardSuccessPopup}
        onHide={(e) => setShowUnAwardSuccessPopup(false)}
        centered
        className="newmodalui wrapper-modal inviteTenantModal max-w-lg awardPropertyModal text-center"
      >
        <Modal.Header>
          <div
            className="cursor-pointer"
            onClick={() => setShowUnAwardSuccessPopup(false)}
          >
            <img
              src={Cancelimg}
              alt="icon"
              className="canceicon topRightIcon"
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          <h2>{_t("unAwardedProp")}</h2>
          <p>{_t("propertyUnawardedSuccessfully")}</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btngreen add-landlord-submit"
            onClick={() => setShowUnAwardSuccessPopup(false)}
          >
            {_t(
              "underStoodButtonAfterUnAwardProp",
              "New award property succes modal"
            )}
          </button>
        </Modal.Footer>
      </Modal>

      <SuccessAwardedPropModal
        showSuccessPopup={showSuccessPopup}
        setShowSuccessPopup={setShowSuccessPopup}
        property={property}
        successTenant={successTenant}
      />
      <ServingPromptModal
        openModal={servingPromptModal}
        profile={currentProfile}
        URL={
          // user?.isParentLL
          //   ? `/${workspaceId}/profile-property?agencylink=${currentProfile?.agency_tenant_link_id}`
          //   :
          `/${workspaceId}/profile-property?sharedprofileid=${currentProfile?._id}`
        }
        setOpenModal={setServingPromptModal}
      />
      <InsuranceSimulationErrorsModal
        show={insuranceSimulationErrorModal}
        onHide={() => setInsuranceSimulationErrorModal(false)}
        errors={insuranceSimulationErrors}
      />
      <InsuranceReviewModal
        show={showInsuranceReviewModal}
        onHide={() => setShowInsuranceReviewModal(false)}
        onGotIt={() => {
          setShowInsuranceReviewModal(false);
        }}
      />
    </>
  );
};

export default LinkedPropertiesPopup;
